var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#373A37",
    strokeWidth: 1.94,
    fill: "#E1F3E1",
    cx: 16,
    cy: 16,
    r: 13.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.648 19.574c.007-1.024.126-1.756.355-2.197.229-.44.737-.993 1.525-1.66.559-.543 1.003-1.064 1.332-1.562.33-.498.494-1.048.494-1.65 0-.694-.188-1.233-.564-1.616-.376-.383-.911-.575-1.606-.575-.594 0-1.099.163-1.514.49-.416.325-.623.807-.623 1.444h-2.514l-.032-.064c-.022-1.275.406-2.269 1.283-2.981.878-.713 2.011-1.07 3.4-1.07 1.504 0 2.677.384 3.518 1.15.842.766 1.263 1.83 1.263 3.19 0 .91-.264 1.753-.79 2.53a9.776 9.776 0 0 1-1.993 2.133c-.408.358-.664.698-.768 1.02-.103.323-.155.795-.155 1.418h-2.61zM17.302 24h-2.665v-2.503h2.665V24z",
    fill: "#363A37",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/Resources.1885b233fd99c976a1cc8de16a83ed19.svg";
export { ForwardRef as ReactComponent };